import React from 'react'

function Separator({ text }) {
	return <span className="separator">{text}</span>
}

export default Separator
